import { gql } from '@apollo/client';

const GET_PICKINGLIST_STATISTICS = gql`query getPickingListStatistics($from:DateTime!, $until:DateTime!){
	pickingList{
		getPickingListStatistics(from: $from, until: $until)
		{
			count
			from
			picker
			to
			weight
		}
	}
}`;

export default GET_PICKINGLIST_STATISTICS; 